import { defineStyleConfig } from '@chakra-ui/react';

export const formLabelTheme = defineStyleConfig({
  baseStyle: {
    fontSize: 'md',
    marginBottom: '5px',
    display: 'inline-block'
  },
  variants: {
    calculator: {
      fontSize: 'xl',
      marginBottom: '5px'
    },
    questionnaire: {
      fontSize: 'lg',
      marginBottom: '5px'
    },
    interestRateFilter: {
      fontWeight: 'bold'
    }
  }
});
